import { PaymentPlanLogType, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePaymentPlanLogs } from '@debbie/cortex/dist/paymentPlans/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import THEME from '../../theme.js';
import { ExternalLink } from '../Icons/index.js';
import { Badge, Modal, Table } from '../index.js';
const Logs = (props) => {
    const paymentPlanLogsLoadable = usePaymentPlanLogs(props.paymentPlanId);
    const paymentPlanLogs = h.hasData(paymentPlanLogsLoadable)
        ? paymentPlanLogsLoadable.data
        : [];
    const [modalOpen, setModalOpen] = useState(false);
    const logs = paymentPlanLogs.filter((log) => log.paymentPlanEntryId === props.paymentPlanEntryId &&
        ![PaymentPlanLogType.DeltaShift].includes(log.type));
    if (logs.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Badge, { onClick: () => setModalOpen(!modalOpen), style: { cursor: 'pointer' }, theme: THEME.NEUTRAL },
            logs.length,
            " ",
            logs.length === 1 ? 'log' : 'logs',
            " ",
            React.createElement(ExternalLink, null)),
        modalOpen && (React.createElement(Modal, { header: 'Logs', onToggle: () => setModalOpen(!modalOpen) },
            React.createElement(Table, null, logs.map((log) => (React.createElement("tr", { key: log.paymentPlanLogId },
                React.createElement("td", null, log.type),
                React.createElement("td", null, moment(log.createdAt).format(THEME.DATE_FORMAT_LONG)),
                React.createElement("td", null, log.details?.message)))))))));
};
export default Logs;
//# sourceMappingURL=PaymentPlanLogs.js.map